<template>
  <div id="contact">
    <b-row>
      <b-col md="12">
        <span>
          <h1>Contact Us</h1>
        </span>
        <span>
          <strong>Soraya Rahmanzai</strong>
        </span>
        <br>
        <span>
          Partnership 2020 Project Coordinator
        </span>
        <br>
        <span>
          <a href="tel:1+4025542375">+1 (402) 554-2375</a>
        </span>
        <br>
        <span>
          <a href="mailto:srahamanzai@unomaha.edu">srahamanzai@unomaha.edu</a>
        </span>
      </b-col>
    </b-row>
    <br>
    <p>
        For more information about the US-India Partnership 2020 initiative,
        request for proposal instructions for sub-grants to US universities,
        and access to other resources, please visit:
    </p>
    <p>
      <a id="wrap" target="_blank" rel="noopener noreferrer" :href="uno_is_url + '/index.php'">{{ uno_is_url }}/index.php</a>
    </p>
    <br v-for="i in [1,2,3,4,5,6,7,8,9,10]">
  </div>
</template>

<script>
export default {
  name: 'Contact',
  data: () => ({
    uno_is_url: 'https://www.unomaha.edu/international-studies-and-programs/engagement/partnership2020'
  }),
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$root.setTitle('Contact')
    })
  }
}
</script>

<style lang="scss" scoped>
  #contact {
    padding-top: 2rem;
    margin-left: auto;
    margin-right: auto;
    width: 45rem;
  }

  h1 {
    padding-bottom: 1rem;
  }

  #wrap {
    overflow-wrap: break-word;
  }

  p {
    padding-bottom: 0rem;
  }

  @media screen and (max-width: 767px) {
    #contact {
      width: 80%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Contact.vue